import { useEffect, useState } from "react";
import "./Products.scss";
import { Slider } from "../Slider/Slider";
import { DualRangeSlider } from "../Components/price-range/DualRangeSlider";
import { useParams } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import { useContextData } from '../ApiContext';
import {
    PHONE_CASE_CATEGORY,
    CASE_TYPES,
    DEVICES,
    CASE_BRANDS,
    CASE_COLORS,
    toSelectedMap,
    keysFromSelectedMap,
    matchParamToKeys,
    buildPhoneCaseQueryParams,
} from './data/phoneCaseFilters';

export function Products({ passed_url, hideOptions = false }) {
    const { category, subcategory } = useParams();
    const url = passed_url || '/products';
    const { queryParams, setQueryParams } = useContextData();

    const [sortOption, setSortOption] = useState("recommended");
    const [queryParamsInit, setQueryParamsInit] = useState(false);

    const [selectedCategories, setSelectedCategories] = useState(() => toSelectedMap(CASE_TYPES));
    const [selectedDevices, setSelectedDevices] = useState(() => toSelectedMap(DEVICES));
    const [selectedBrands, setSelectedBrands] = useState(() => toSelectedMap(CASE_BRANDS));
    const [selectedColors, setSelectedColors] = useState(() => toSelectedMap(CASE_COLORS));

    useEffect(() => {
        const matchedDevice = matchParamToKeys(subcategory, DEVICES);
        const matchedCaseType = matchParamToKeys(category, CASE_TYPES);
        const nextCaseTypes = toSelectedMap(CASE_TYPES, matchedCaseType);
        const nextDevices = toSelectedMap(DEVICES, matchedDevice);
        setSelectedCategories(nextCaseTypes);
        setSelectedDevices(nextDevices);

        const queryList = buildPhoneCaseQueryParams({
            caseType: keysFromSelectedMap(nextCaseTypes),
            subcategory: keysFromSelectedMap(nextDevices),
            brand: [],
            color: [],
            price: queryParams.price,
            sort: sortOption,
        });

        if (
            matchParamToKeys(category, [PHONE_CASE_CATEGORY]).length &&
            matchedDevice.length
        ) {
            queryList.category = [PHONE_CASE_CATEGORY];
            queryList.subcategory = matchedDevice;
        }

        setQueryParams(queryList);
        setQueryParamsInit(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setSortOption(queryParams.sort || 'popularity');
        if (Array.isArray(queryParams.caseType)) {
            setSelectedCategories(toSelectedMap(CASE_TYPES, queryParams.caseType));
        }
        if (Array.isArray(queryParams.subcategory)) {
            setSelectedDevices(toSelectedMap(DEVICES, queryParams.subcategory));
        }
        if (Array.isArray(queryParams.brand)) {
            setSelectedBrands(toSelectedMap(CASE_BRANDS, queryParams.brand));
        }
        if (Array.isArray(queryParams.color)) {
            setSelectedColors(toSelectedMap(CASE_COLORS, queryParams.color));
        }
    }, [queryParams]);

    const handleChange = (event, facet) => {
        const { name, checked } = event.target;
        let nextCaseTypes = selectedCategories;
        let nextDevices = selectedDevices;
        let nextBrands = selectedBrands;
        let nextColors = selectedColors;

        if (facet === 'caseType') {
            nextCaseTypes = { ...selectedCategories, [name]: checked };
            setSelectedCategories(nextCaseTypes);
        } else if (facet === 'device') {
            nextDevices = { ...selectedDevices, [name]: checked };
            setSelectedDevices(nextDevices);
        } else if (facet === 'brand') {
            nextBrands = { ...selectedBrands, [name]: checked };
            setSelectedBrands(nextBrands);
        } else if (facet === 'color') {
            nextColors = { ...selectedColors, [name]: checked };
            setSelectedColors(nextColors);
        }

        setQueryParamsInit(true);
        setQueryParams(
            buildPhoneCaseQueryParams({
                caseType: keysFromSelectedMap(nextCaseTypes),
                subcategory: keysFromSelectedMap(nextDevices),
                brand: keysFromSelectedMap(nextBrands),
                color: keysFromSelectedMap(nextColors),
                price: queryParams.price,
                sort: sortOption,
            })
        );
    };

    const handleSortChange = (event) => {
        const nextSort = event.target.value;
        setSortOption(nextSort);
        setQueryParams({
            ...queryParams,
            ...(nextSort && nextSort !== 'popularity' && nextSort !== 'recommended'
                ? { sort: nextSort }
                : (() => {
                    const { sort, ...rest } = queryParams;
                    return rest;
                })()),
        });
    };

    const renderCheckboxGroup = (title, map, facet) => (
        <div className="categories-container">
            <span className="vertical-filters-header">{title}</span>
            <ul className="categories-list">
                {Object.keys(map).map((key) => (
                    <li key={key}>
                        <label className="filters-label">
                            <input
                                type="checkbox"
                                className="styled-checkbox"
                                name={key}
                                checked={!!map[key]}
                                onChange={(e) => handleChange(e, facet)}
                            />
                            <span>{key}</span>
                        </label>
                    </li>
                ))}
            </ul>
        </div>
    );

    return (
        <div className="product" style={isMobile ? { marginTop: "-10rem" } : { marginTop: "0rem" }}>
            <div className="innerFilter2" style={hideOptions ? { display: 'none' } : null}>
                <div>Filters</div>
                <div className="sort-sortBy">
                    Sort by:
                    <span> {sortOption}</span>
                    <ul className="sort-list">
                        {["recommended", "whatsNew", "popularity", "betterDiscount", "priceHighToLow", "priceLowToHigh", "customerRating"].map((option) => (
                            <li key={option}>
                                <label className="sort-label">
                                    <input
                                        type="radio"
                                        value={option}
                                        checked={sortOption === option}
                                        onChange={handleSortChange}
                                    />
                                    {option.charAt(0).toUpperCase() + option.slice(1).replace(/([A-Z])/g, ' $1')}
                                </label>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="mainContent">
                <div className="ContentWrapper">
                    <div className="filterContainer" style={hideOptions ? { display: 'none' } : null}>
                        <div className="filter">
                            {renderCheckboxGroup('Case Type', selectedCategories, 'caseType')}
                            {renderCheckboxGroup('Device', selectedDevices, 'device')}
                            {renderCheckboxGroup('Brand', selectedBrands, 'brand')}
                            {renderCheckboxGroup('Color', selectedColors, 'color')}
                            <div className="categories-container price-filter-section">
                                <span className="vertical-filters-header">Price</span>
                                <DualRangeSlider setQueryParams={setQueryParams} />
                            </div>
                        </div>
                    </div>
                    <Slider url={url} queryParams={queryParams} queryParamsInit={queryParamsInit} setQueryParamsInit={setQueryParamsInit} />
                </div>
            </div>
        </div>
    );
}
